import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { GlobalService } from '../global/global.service';
import { RescueStoreService } from './rescue-store.service';


interface IFounds {
  datos: { listaFondoClass: { codigoMoneda: string; claseFondo: string }[] };
}

interface IFoundsPromotor {
  datos: { listaFondoClass: { codigoMoneda: string; claseFondo: string }[], promotor : { nombre: string}};
}

interface IViaPay {
  datos: { viasDePagos: [] }
}

interface IRescue {
  datos: { rescate: [] }, resultado: [] 
}

interface IAagente {
  datos: { agentesColocadores: [] }, resultado: [] 
}

@Injectable({
  providedIn: 'root',
})
export class RescueRequestsService {
  constructor(
    private http: HttpClient, 
    private globalService: GlobalService, 
    public rescueStore: RescueStoreService,) {}

  getFounds(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/rescate/private/listarFondos/${params.cuc}`)
      .pipe(map((apiResponse: IFounds) => this.mapGetFounds(apiResponse)));
  }

  mapGetFounds(apiResponse: { datos: { fondos: [] } } | any) {
    if(apiResponse.datos && apiResponse.datos.fondos){
      return apiResponse.datos.fondos;
    }
    return [];
  }

  getFoundsPromotor(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/rescate/private/listarFondos/${params.cuc}`)
      .pipe(map((apiResponse: IFoundsPromotor) => this.mapGetFoundsPromotor(apiResponse)));
  }

  mapGetFoundsPromotor(apiResponse: { datos: { fondos: [], promotor:{}} } | any) {
    if(apiResponse.datos && apiResponse.datos.fondos){
      return apiResponse.datos.promotor;
    }
    return null;
  }

  getListBank(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/rescate/private/listarViaPago/${params.cuc}`)
      .pipe(map((apiResponse: IViaPay) => this.mapGetBanks(apiResponse)));
  }

  mapGetBanks(apiResponse: { datos: { viasDePagos: [] } } | any) {
    
      var list = [];
      if(apiResponse.datos && apiResponse.datos.viasDePagos){
        apiResponse.datos.viasDePagos.forEach((f, key) => {
          f.formasPagos.forEach((g, k) => {
            g.cuentasBancarias.forEach((h, ke) => {
              var viasPago = {
                codigoViaPago: "",
                desViaPago: "",
                codigoFormaPago: "",
                formaPago:"",
                tipoCuentaBancaria: "",
                numeroCuenta: "",
                codigoMoneda: "",
                id: "",
                codigoViaPagoid: "",
                agente:""
              };
              viasPago.codigoViaPago = f.codigoViaPago;
              viasPago.desViaPago = f.desViaPago;
              viasPago.codigoFormaPago = g.codigoFormaPago;
              viasPago.formaPago = g.formaPago;
              viasPago.tipoCuentaBancaria = h.tipoCuentaBancaria;
              viasPago.numeroCuenta = h.numeroCuenta;
              viasPago.codigoMoneda = h.codigoMoneda;
              viasPago.agente = h.agente;
              viasPago.id = h.id;
              viasPago.codigoViaPagoid = f.codigoViaPago + (h.id?h.id:'');
              list.push(viasPago)
            });
            
          });
          
        });
      }

    return list;
  }

  validateRescue(params): Observable<any> {
    
    return this.http.post(
      `${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/rescate/private/validarRescate`,
      params,
      {}
    );
    
      /*return this.http
      .post(`http://localhost:8082/api/fondos-rescate-service/validarRescate/${params.tipoDocumento}/${params.numeroDocumento}`, params)*/
  }

  saveRescue(params): Observable<any> {
      
    return this.http.post(
      `${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/rescate/private/grabarRescate?codigo=${params.codigo}&proceso=${params.proceso}`,
      params,
      {}
    );
 // }
      /*return this.http
      .post(`http://localhost:8082/api/fondos-rescate-service/grabarRescate/${params.tipoDocumento}/${params.numeroDocumento}?codigo=${params.codigo}`, params)*/
  }

  sendMail(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/rescate/private/enviarMail/${params}`,'')
  }

  getRescue(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/rescate/private/listarRescates/${params.cuc}`)
      .pipe(map((apiResponse: IRescue) => this.mapgetRescue(apiResponse)));
  }

  mapgetRescue(apiResponse: { datos: { listaRescate: [] }, resultado: {} } | any) {
    if(apiResponse.datos && apiResponse.datos.listaRescate){
      return apiResponse.datos.listaRescate;
    }
    return [];
  }

  cancelRescue(params): Observable<any> {
    return this.http
      .post(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/rescate/private/cancelarRescate`, {
            idOperacion: params.idOperacion,
            cuc: params.cuc,
            area: 'EXT',
      })
  }

  getAgents(params): Observable<any> {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/rescate/private/listarAgenteColocador/${params.cuc}`)
      .pipe(map((apiResponse: IAagente) => this.mapGetAgents(apiResponse)));
  }

  mapGetAgents(apiResponse: { datos: { agentesColocadores: [] } , resultado: {} } | any) {
    if(apiResponse.datos && apiResponse.datos.agentesColocadores){
      return apiResponse.datos.agentesColocadores;
    }
    return [];
  }

  resetRescueData() {
    this.rescueStore.RESCATE_FONDS= []
    this.rescueStore.RESCATE_BANKS= []
    delete this.rescueStore.RESCATE_DATA
    delete this.rescueStore.RESCATE_CONFIRM_DATA
  }
}
